import moment from 'moment';

const STORED_DATE_FORMAT = 'YYYY-MM-DD';
const DISPLAY_DATE_FORMAT = 'MMM D, YYYY';

// Parse the stored string as a local date; `new Date('2026-10-14')` is UTC
// midnight and shows as the 13th west of UTC.
export const formatCustomFieldDate = (value: unknown): string => {
  if (typeof value !== 'string') return '';
  const parsed = moment(value, STORED_DATE_FORMAT, true);
  return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : '';
};

export const toStoredCustomFieldDate = (date: moment.Moment): string =>
  date.format(STORED_DATE_FORMAT);

export const parseStoredCustomFieldDate = (value: unknown) => {
  if (typeof value !== 'string') return null;
  const parsed = moment(value, STORED_DATE_FORMAT, true);
  return parsed.isValid() ? parsed : null;
};
